import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { GriddataService } from '../services/griddata.service';
import { Subscription, forkJoin } from 'rxjs';
import { GridRefreshComponent } from '../core/grid/grid-refresh/grid-refresh.component';
import { OSPStateService } from '../services/osp-state.service';
import { LookupService } from '../services/lookup/lookup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { logErrors } from '../shared/logger';
import { HeaderCheckboxComponent } from '../core/grid/header-checkbox/header-checkbox.component';
import { RowCheckboxComponent } from '../core/grid/row-checkbox/row-checkbox.component';

import { PitchfreezingMsg, dateFilterComparator, getTimezone, resetSortingAndFilters,checkInvAccess } from '../constants';

import { UpdatedStockingPaceComponent } from './updated-stocking-pace.component';
import { StockingPaceServiceService } from '../services/stocking-pace-service.service';
import { ExcelService } from '../services/excel.service';
import { validateVanningDates, warningMessage } from '../constants';
import * as mm from 'moment-timezone';

import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
import { ConfirmCancelDailogComponent } from '../core/confirm-cancel-dailog/confirm-cancel-dailog.component';
import {
  dateComparator,
  successMessage,
  checkAccessPipe,
} from '../constants';
import { TemplateStockingPaceMaintenanceComponent } from './template/template-stocking-pace-maintenance';
import * as XLSX from 'xlsx';
import { FluctuationAllowanceService } from '../services/fluctuation-allowance/fluctuation-allowance.service';
import { ReviewEditedspaceComponent } from './edit-space/review-editedspace.component';

@Component({
  selector: 'app-stocking-pace-maintenance',
  templateUrl: './stocking-pace-maintenance.component.html',
  styleUrls: ['./stocking-pace-maintenance.component.scss'],
})
export class StockingPaceMaintenanceComponent implements OnInit {
  headerCheckboxChecked: any;
  // dateComparator: any;
  @ViewChild('osPartsGrid') osPartsGrid;
  @ViewChild('upload') fileInput: ElementRef<HTMLInputElement>;
  isEditMode = false;
  showDownloadUploadButtons: boolean = false;
  editEnabled: boolean = false;
  defaultPageSize: any = 100000;
  offset: number = 0;
  user: any;
  userRole: any;
  dataCount: number = 0;
  stockingPaceSubscription$: Subscription;
  selectedDock: any = [];
  selectedModuleType: any = [];
  selectedVanMonth: any = [];

  columnDefs: any;
  rowData: any;
  rowSelection: any;
  gridOptions: any;
  pagination: any;
  paginationPageSize: any;
  context: any;
  suppressClickEdit: boolean;
  frameworkComponents: any;
  tooltipShowDelay: any;
  editType: any;
  search_form = {
    dock: '',
    module_type: '',
    van_month: '',
  };
  dockModuleList: any = [];
  dockList: any = [];
  vanMonthList: any = [];
  moduleTypeList: any = [];
  vanMonthWiseList: any = [];
  selectedVanMonthWise: any[];

  modalComponent = 'modal-component';
  editApiDefaultLimit = 200;
  timesEditApiCalled: number = 0;
  editApiStartPosition: number = 0;
  editApiEndPosition: number = this.editApiDefaultLimit;
  itContact: string;
  vanningFrom;
  vanningTo;
  planStockingDT;
  batchCheck = true;
  access;
  accessEdit = false;
  filterList: any = [];
  containerList: any = [];
  renbanList: any = [];
  
  uploadError: boolean;
  uploading: boolean = false;
  exportData: any;
  headersSameAsUI = [
    'BUSINESS ENTITY',
    'DOCK',
    'CONTAINER RENBAN', 
    'MODULE NUMBER',
    'STOCKING PACE',
  ];
  headersSameAsUIError = [
    'BUSINESS ENTITY',
    'DOCK',
    'CONTAINER RENBAN', 
    'MODULE NUMBER',
    'STOCKING PACE',
    'COMMENTS'
  ];
  fileBuffer: any;
  fileName: string;
  files: any[];
  actualFileName: string;
  allowedFilesize: number;
  justFileName: string;
  validating: boolean;
  warningMessageUpload: string;
  responseBody : any;
  
  constructor(
    private readonly gridDataService: GriddataService,
    private readonly stateService: OSPStateService,
    private readonly lookupService: LookupService,
    private readonly spinner: NgxSpinnerService,
    private readonly stockingService: StockingPaceServiceService,
    private readonly excelService: ExcelService,
    private readonly dialog: MatDialog,
    private readonly flalService: FluctuationAllowanceService
  ) {
    this.context = {
      componentParent: this,
    };
  }
  headers = [
    'BUSINESS ENTITY',
    'DOCK',
    'CONTAINER RENBAN',
    'MODULE NUMBER',
    'STOCKING PACE',
  ];
  ngOnInit(): void {

    this.access = checkInvAccess();
    this.accessEdit = this.access?.functionalityAccess?.edit || false;

    //let today = new Date();
    // this.planStockingDT = String(mm().tz(getTimezone(this.namcValue)).format('MM/DD/YYYY')).substring(0, 10); //today.toISOString().split('T')[0];

    const access = checkAccessPipe();
    this.selectedVanMonth = this.vanMonthWiseList[0];
  
    this.columnDefs = [
      {
        headerName: '',
        field: 'rowCheckBox',
        // suppressSorting: true,
        width: 46,
        headerComponentParams: {
          headerChecked: this.headerCheckboxChecked,
        },
        headerComponentFramework: HeaderCheckboxComponent,
        floatingFilterComponentFramework: GridRefreshComponent,
        floatingFilterComponentParams: { suppressFilterButton: true },

        cellRendererFramework: RowCheckboxComponent,
        floatingFilter: true,
      },
      {
        headerName: 'Module Type',
        field: 'module_type',
        width: 120,
        floatingFilter: true,
        headerTooltip: 'Module Type',
        tooltipField: 'duration',
      },
      {
        headerName: 'Renban',
        field: 'container_renban',
        width: 90,
        floatingFilter: true,
        tooltipField: 'name',
      },
      {
        headerName: 'Module',
        field: 'module_number',
        width: 90,
        floatingFilter: true,
      },
      {
        headerName: 'Van DT',
        field: 'vandt',
        width: 120,
        floatingFilter: true,
        sortable: true,

        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
          comparator: dateFilterComparator,
        },
      },
      {
        headerName: 'Plan Stock DT/Time',
        field: 'planstockingdt',
        width: 150,
        floatingFilter: true,
      },
      {
        headerName: 'Stocking Pace',
        field: 'est_stocking_pace',
        width: 140,
        floatingFilter: true,
        valueGetter: (params) => {
          return parseFloat(params.data.est_stocking_pace) || null;
        },
      },

      {
        headerName: 'Actual/Updated stocking Pace',
        field: 'modifiedStockingPace',
        width: 200,
        cellRendererFramework: UpdatedStockingPaceComponent,
        cellRendererParams: { column: 'modified_stocking_pace' },
        floatingFilter: true,
        valueGetter: (params) => {
        
          const value =
            parseFloat(params.data.modifiedStockingPace?.value) || parseFloat(params.data.modified_stocking_pace);
          return isNaN(value) ? null : value; // Ensure returning numeric values or null
        },
      },

      {
        headerName: 'Updated DT',
        field: 'updateddt',
        width: 190,
        floatingFilter: true,
        headerTooltip: 'Updated Date(mm/dd/yyyy hh:mm:ss (Eastern))',
      },
      {
        headerName: 'User',
        field: 'updated_userid',
        width: 198,
        floatingFilter: true,
        tooltipField: 'userid',
      },
    ];

    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.gridOptions = this.gridDataService.getGridOptions();
    this.gridOptions.onGridReady = function (params) {
      this.gridApi = params.api;
    };

    this.stockingPaceSubscription$ = this.stateService.getNamc().subscribe((observable) => {
      this.initializeData();
      this.loadDropdown();
    });
  }

  dateComparator(date1: Date, date2: Date): number {
    if (date1 < date2) {
      return -1; // date1 is earlier
    } else if (date1 > date2) {
      return 1; // date1 is later
    } else {
      return 0; // dates are equal
    }
  }

  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('userName');
  namcName = localStorage.getItem('namcName');
  

  warningMessage: string;
  successMessage: string;

  removeMessage() {
    this.successMessage = '';
    this.warningMessage = '';
    this.warningMessageUpload = '';
  }

  userCheckChanged(checked, rowIndex) {
    this.spinner.show();
    const rowNode = this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);
    if (checked === true) {
      rowNode.setSelected(true);
      if (this.isEditMode) {
        rowNode.data.checkedEditMode = true;
      }
      rowNode.data.rowCheckBox = true;
    } else {
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
    }

    this.gridOptions.getRowStyle = function (params) {
      if (params.node.rowIndex === rowIndex) {
        const color = checked ? '#E4ECF0' : 'white';
        return { background: color };
      }
      return { background: 'white' };
    };

    rowNode.setData(rowNode.data);
    this.toggleHeaderCheckbox(checked);
    this.spinner.hide();
  }
  toggleHeaderCheckbox(checked) {
    if (!checked) {
      this.headerCheckboxChecked = false;

      this.osPartsGrid.gridOptions.api.refreshHeader();

      return;
    }

    const rowCount = this.osPartsGrid.gridOptions.rowData.length;
    const selectedRowCount = this.osPartsGrid.gridOptions.rowData.filter((x) => x.rowCheckBox === true).length;

    if (rowCount === selectedRowCount) {
      this.headerCheckboxChecked = true;

      this.osPartsGrid.gridOptions.api.refreshHeader();
    }
  }
  headerCheckChanged(event) {
    this.headerCheckboxChecked = event.checked;
    const headerChecked = event.checked;
    const isEditable = this.isEditMode;
    this.osPartsGrid.gridOptions.api.forEachNode(function (rowNode, index) {
      if (headerChecked) {
        if (isEditable) {
          rowNode.data.checkedEditMode = true;
        }
        rowNode.data.rowCheckBox = true;
      } else {
        rowNode.data.rowCheckBox = false;
        rowNode.data.checkedEditMode = false;
      }
      rowNode.setData(rowNode.data);
    });
  }

  onEditMode() {
    this.removeMessage();
    let data = [];

    data = this.getModifiedRowData();
    if (data.length > 0) {
      this.isEditMode = !this.isEditMode;
      this.editEnabled = this.isEditMode;

      if (this.isEditMode) {
        this.osPartsGrid.gridOptions.api.forEachNode(function (rowNode, index) {
          rowNode.data.checkedEditMode = true;
          if (!rowNode.data.rowCheckBox) {
            rowNode.data.checkedEditMode = false;
          }
          rowNode.setData(rowNode.data);
        });
      } else {
        this.osPartsGrid.gridOptions.api.forEachNode(function (rowNode, index) {
          if (rowNode.data.rowCheckBox) {
            rowNode.data.checkedEditMode = false;
          }
          rowNode.setData(rowNode.data);
        });
      }
      setTimeout(() => {
        window.scroll(0, document.body.scrollHeight);
      }, 100);
    } else {
      this.isEditMode = false;
      this.editEnabled = false;
      //this.warningMessage = warningMessage.selectRowsToEdit;
      window.scroll(0, 0);
    }
  }

  
  getModifiedRowData(): any {
    this.modifiedRowData = this.rowData.filter((row) => row.rowCheckBox);
   
    return this.modifiedRowData;
  }

  onResetDropDown() {
    this.removeMessage();
    this.editEnabled = false;
    this.isEditMode = false;
    this.planStockingDT = '';
    this.selectedDock = [];
    this.selectedModuleType = [];
    this.selectedVanMonth = [];

    this.selectedModuleType.push({ module_type: 'ALL' });
    this.vanningFrom = '';
    this.vanningTo = '';
    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }

    this.setPageSizeToAll(this.defaultPageSize);

    this.rowData = [];

    this.offset = 0;
  }

  onSearch(offset) {
    //this.refreshView()
    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }
    this.removeMessage();
    this.editEnabled = false;
    this.isEditMode = false;

    if (offset === 0) {
      this.setPageSizeToAll(this.defaultPageSize);
      this.rowData = [];
      this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
      const { valid, error } = validateVanningDates({ vanningFrom: this.vanningFrom, vanningTo: this.vanningTo });
      if (!valid) {
        this.warningMessage = error;
        window.scroll(0, 0);
        this.spinner.hide();
        return;
      }
      this.offset = 0;
      this.spinner.show();
    }
    if (!this.checkIfAnySelected()) {
      this.rowData = [];
      let msg = `Please select`;
      let before = false;
      if (this.selectedModuleType.length == 0) {
        msg += ` MODULE TYPE`;
        before = true;
      }
      if (!this.vanningFrom) {
        if (before) msg += ` and`;
        msg += ` VAN FROM`;
        before = true;
      }
      if (!this.vanningTo) {
        if (before) msg += ` and`;
        msg += ` VAN TO`;
        before = true;
      }
      this.warningMessage = msg;

      window.scroll(0, 0);
      this.spinner.hide();
      return false;
    }

    let kanban;

    let selectedModuleType;
    let selectedVanMonth;

    if (this.selectedModuleType.length > 0) {
      if (!this.selectedModuleType.some((a) => a.module_type === 'ALL')) {
        selectedModuleType = [];
        this.selectedModuleType.forEach((element) => {
          selectedModuleType.push(element.module_type);
        });
      }
      if (this.selectedVanMonth.length > 0) {
        if (!this.selectedVanMonth.some((a) => a.vanning_month === 'ALL')) {
          selectedVanMonth = [];
          this.selectedVanMonth.forEach((element) => {
            selectedVanMonth.push(element.vanning_month);
          });
        }
      }
    }

    const data = {
      offset: offset,
      limit: 12000,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,

      module_type: selectedModuleType,
      vanningFrom: this.vanningFrom,
      vanningTo: this.vanningTo,
      planStockingDT: this.planStockingDT,
    };

    this.stockingService.getStockingPaceMaintenanceData(data).subscribe({
      error: (error) => this.errorCallback(error, 'getStockingPaceMaintenanceData'),
      next: (res) => {
        if (res.body && res.body.data) {
          this.rowData.push(...res.body.data);
          this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
          this.dataCount = parseInt(res.body.rowCount);
          const records = this.dataCount - (this.offset + 1) * 12000;
          if (records >= 1) {
            this.offset++;
            this.onSearch(this.offset * 12000);
          } else {
            this.spinner.hide();
          }
        } else {
          this.rowData = [];
          this.spinner.hide();
        }

        this.setPageSizeToAll();
      },
    });
    return true;
  }
  resetGrid() {
    if (this.osPartsGrid) {
      resetSortingAndFilters(this.osPartsGrid);

      return;
    }
  }

  setPageSizeToAll(pageSize?) {
    this.paginationPageSize = this.rowData.length;

    if (pageSize) {
      this.paginationPageSize = 0;
      this.rowData.length = 0;
    }

    this.onPageSizeChanged();
  }

  checkIfAnySelected() {
    if (this.selectedModuleType.length > 0 ) {
      return true;
    }
    return false;
  }
  initializeData() {
   
    this.rowData = [];
    this.spinner.show();

    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }
    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }
    if (localStorage.getItem('UserName')) {
      this.userName = localStorage.getItem('UserName');
    }
    if (localStorage.getItem('namcName')) {
      this.namcName = localStorage.getItem('namcName');
    }
  

    this.loadDrop();
    this.onResetDropDown();
  }

  errorCallback = (error, apiName = '') => {
    logErrors(error);
    this.spinner.hide();

    let detailedMessage = 'Something went wrong! Please contact support team.';
    let backendMessage = '';
    if (error?.error?.message) {
      backendMessage = error.error.message;
    } else if (error?.message) {
      backendMessage = error.message;
    }
    if (backendMessage) {
      detailedMessage += `| ${backendMessage}`;
    } else if (apiName) {
      detailedMessage += `| Try after some time! Error in ${apiName}`;
    }
    this.warningMessage = detailedMessage;
    this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };

  loadDrop() {
    var data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
    };
    const lookupSubscriptions = [
      this.stockingService.getMaintenanceModuleType(),
      this.stockingService.pitchBatchStatus(data),
    ];
    forkJoin(lookupSubscriptions).subscribe({
      next: (res) => {
        this.moduleTypeList = [];

        this.moduleTypeList.push({ module_type: 'ALL' });
        this.selectedModuleType = [];

        this.selectedModuleType.push({ module_type: 'ALL' });
        if (res[0]?.body && res[0].body !== 'No Content') {
          this.moduleTypeList.push(...res[0].body);
        } else if (res[0]?.body === 'No Content') {
          this.warningMessage = 'No module types available.';
        }
        const status = res[1].body.data[0]?.status;
      

        if (status === 'RUNNING') {
          this.warningMessage = `${PitchfreezingMsg}`;
        

          this.spinner.hide();
          this.batchCheck = true;
          this.showDownloadUploadButtons = false;
        } else {
          this.warningMessage = '';
          this.batchCheck = false;
          this.showDownloadUploadButtons = true;
        }

        this.spinner.hide();
      },
      error: (error) => this.errorCallback(error),
    });
  }

  dockChange(): void {
    if (this.selectedDock.length >= 1) {
      if (this.selectedDock[this.selectedDock.length - 1].dock === 'ALL') {
        this.selectedDock = [];
        this.selectedDock.push(this.dockList[0]);
      } else {
        let indexAll = this.selectedDock.findIndex((data) => data.dock === 'ALL');

        if (indexAll > -1) {
          this.selectedDock.splice(indexAll, 1);
        }
      }
    }
  }
  onPageSizeChanged() {
    if (this.gridOptions?.api) {
      this.gridOptions.api.paginationSetPageSize(Number(this.paginationPageSize));
    }
  }

  onDockChange() {
    this.moduleTypeList = [];

    this.dockModuleList.forEach((element) => {
      if (element.dock === this.selectedDock) {
        this.moduleTypeList.push({ module_type: element.module_type });
      }
    });

   
  }

  exportAsXLSX(): void {
    this.removeMessage();

    this.spinner.show();

    const easternCurrentDate = String(mm().tz(getTimezone(this.namcValue)).format('YYYY-MM-DD_HH:mm:ss'));
   
    let data = [];

    if (this.headerCheckboxChecked) {
      this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
        data.push(node.data);
      });
    } else {
      data = this.getModifiedRowData();
    }

    if (data.length < 1) {
      this.spinner.hide();
      this.warningMessage = warningMessage.noRowsSelected;

      window.scroll(0, 0);
    } else {
      setTimeout(async () => {
        if (this.rowData.length > 0) {
          const exportData: any = [];

          data.forEach((e) => {
            const obj = {
              module_type: e.module_type,
              container_renban: e.container_renban,
              module_number: e.module_number,
              vandt: e.vandt,
              est_stocking_pace: e.est_stocking_pace,
              modifiedStockingPace: e.modified_stocking_pace,
              updated_userid: e.updated_userid,
              updateddt: e.updateddt,
            };
            exportData.push(obj);
          });

          const headers = [
            'MODULE TYPE',
            'RENBAN',
            'MODULE',
            'VAN DT',
            'STOCKING PACE',
            'ACTUAL/UPDATED STOCKING PACE',
            'USER ID',
            'UPDATED DT',
          ];

          const timestamp = easternCurrentDate
            .split('.')[0]
            .replace('T', '_')
            .split('')
            .filter((d) => d !== '-' && d !== ':')
            .join('');

          this.excelService.exportAsExcelFile(exportData, 'Stockingpace-maintenance_' + timestamp, headers);
        }
        this.spinner.hide();
      }, 1000);
    }
  }

  openDialog1() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.height = '250px';
    dialogConfig.width = '470px';
    dialogConfig.data = 'ospipe';
    const dialogRef = this.dialog.open(ConfirmCancelDailogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res === 'cancel') {
        this.columnDefs[7].cellStyle = function (params) {
          if ('modified' in params.data) {
            return { backgroundColor: '#E4ECF0' };
          } else {
            return { backgroundColor: 'white' };
          }
        };

        this.onSearch(0);
        this.editEnabled = false;
        this.isEditMode = false;
        this.osPartsGrid.gridOptions.api.refreshHeader();
      }
    });
  }
  cancelEdit(): void {
    this.removeMessage();
    this.openDialog1();
  }
  modifiedRowData = [];

  updatedRows = [];
  edit() {
    this.spinner.show();
    this.removeMessage();

    this.getBatchStatus(this.editAPIcall);
    //
     this.editAPIcall()
  }

  editAPIcall = async () => {
    var editedRecords = this.getModifiedRowData();

    this.updatedRows = editedRecords.filter((element) => element.isUpdated);

    if (this.updatedRows.length === 0) {
      this.warningMessage = warningMessage.editToReview;
      this.spinner.hide();
      window.scroll(0, 0);
      return;
    }

   
    if (this.updatedRows) {
      var updatedData = [];
      this.updatedRows.forEach((e) => {
        var updatedFields = {
          container_renban: e.container_renban,
          modified_stocking_pace: e.modified_stocking_pace,
          module_type: e.module_type,
          vanning_from: e.vanning_from,
          vanning_to: e.vanning_to,
          module_number: e.module_number,
          total_module_qty: e.total_module_qty,
          userid: this.userName,
        };
        updatedData.push(updatedFields);
      });

      this.spinner.show();
      this.editStocking(updatedData);
    }
  };
  onModuleTypeChange(): void {
    if (this.selectedModuleType.length >= 1) {
      if (this.selectedModuleType[this.selectedModuleType.length - 1].module_type === 'ALL') {
        this.selectedModuleType = [];
        this.selectedModuleType.push(this.moduleTypeList[0]);
      } else {
        let indexAll = this.selectedModuleType.findIndex((data) => data.module_type === 'ALL');

        if (indexAll > -1) {
          this.selectedModuleType.splice(indexAll, 1);
        }
      }
    }
  }
  editStocking(updatedData) {
    var data1 = {
      business_entity: this.namcValue,
      userid: this.userName,
      workid: this.user,
      user_role: this.userRole,
      data: updatedData.slice(this.editApiStartPosition, this.editApiEndPosition),
    };

    this.spinner.show();
    this.stockingService.stokingEdit(data1).subscribe({
      error: (error) => this.errorCallback(error, 'stokingEdit'),
      next: (response) => {
       

        const updatedRows = response.body.updatedRows;

        if (updatedData.length > this.editApiEndPosition) {
          this.timesEditApiCalled++;

          this.editApiStartPosition = this.timesEditApiCalled * this.editApiDefaultLimit;

          this.editApiEndPosition = this.editApiStartPosition + this.editApiDefaultLimit;
          return this.editStocking(updatedData);
        }

        this.spinner.hide();
        this.timesEditApiCalled = 0;
        this.editApiStartPosition = 0;
        this.editApiEndPosition = this.editApiDefaultLimit;

        if (updatedRows.length > 0) {
          this.successMessage = successMessage.recordUpdated;
          this.rowData = updatedRows;
        } else {
          this.warningMessage = `${warningMessage.reportsNotUpdated}  ${this.itContact}.`;
        }
        this.editEnabled = false;
        this.isEditMode = false;
        window.scroll(0, 0);
        this.setPageSizeToAll();
      },
    });
  }




 processStockingData(inputdata: any[]): any[] {
  const groups = new Map<string, any[]>();

  // Step 1: Group rows by dock + container_renban
  inputdata.forEach(row => {
    const key = `${row.dock}|${row.container_renban}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push(row);
  });

  const output: any[] = [];

  groups.forEach(group => {
    // Step 2: Look at modified values only from rows marked is_modified = true
    const modifiedRows = group.filter(r => r.is_modified === true);
    const modifiedValues = Array.from(
      new Set(
        modifiedRows
          .map(r => r.modified_stocking_pace)
          .filter(v => v !== null && v !== undefined && v !== "")
      )
    );

    if (modifiedValues.length > 1) {
      // Conflict → error for all rows in this group
      group.forEach(r =>
        output.push({
          ...r,
          error:
            "Stocking pace sholud be consistent within same dock and container renban"
        })
      );
    } else if (modifiedValues.length === 1) {
      // One unique modified value → propagate to all rows in the group
      const newVal = modifiedValues[0];
      group.forEach(r =>
        output.push({
          ...r,
          modified_stocking_pace: newVal,
          error: ""
        })
      );
    } else {
      // No is_modified = true rows → return group as-is
      group.forEach(r => output.push({ ...r, error: "" }));
    }
  });

  return output;
}
 
 mergeWithModifiedFlag(inputdata1, inputdata2) {
  // Create a Set of unique keys from inputdata1 for quick lookup
  const input1Keys = new Set(
    inputdata1.map(
      row => `${row.dock}|${row.container_renban}|${row.module_number}`
    )
  );

  // Process inputdata2 and add is_modified field
  const outputArray = inputdata2.map(row => {
    const key = `${row.dock}|${row.container_renban}|${row.module_number}`;
    const isModified = input1Keys.has(key);
    return { ...row, is_modified: isModified };
  });

  return outputArray;
}
 
 



ReviewChanges() {
  // Step 1: Get modified rows
  this.modifiedRowData = this.getModifiedRowData();

  if (this.modifiedRowData.length === 0) {
    window.scroll(0, 0);
    return;
  }

  // Step 2: Only keep updated ones
  this.modifiedRowData = this.modifiedRowData.filter((element) => element.isUpdated);
  console.log("modifiedRowData",this.modifiedRowData)

  if (this.modifiedRowData.length === 0) {
    window.scroll(0, 0);
    return;
  }

  // Step 3: Track rows from rowData that get updated
  let updatedRows: any[] = [];

  this.modifiedRowData.forEach((modifiedRow) => {
    const rows = this.rowData.filter(
      r =>
        r.dock === modifiedRow.dock &&
        r.container_renban === modifiedRow.container_renban 
    );
  
    rows.forEach(row => {
      const alreadyExists = updatedRows.some(
        r =>
          r.dock === row.dock &&
          r.container_renban === row.container_renban &&
          r.module_number === row.module_number
      );
  
      if (!alreadyExists) {
        updatedRows.push(row);
      }
    });
  });
  
updatedRows= this.mergeWithModifiedFlag(this.modifiedRowData,updatedRows) 
   const validatedrows=this.processStockingData(updatedRows)
   console.log('validated rws',validatedrows)

  // Step 4: Optional error collection (empty for now)
  Promise.all(
    updatedRows.map(async (element, index) => {
      let p = [];
      element.error = '';

      if (p.length > 0) {
        element.error = p
          .map(function (val, index) {
            return `${(index + 1).toString()}.   ${val}`;
          })
          .join('\n');
      }
    })
  );

  // Step 5: Open dialog with all updated rows
  this.openReviewDialog(validatedrows);
}

  
  

  openReviewDialog(editedRecords) {
    var data = {
      modifiedRowData: editedRecords,
    };
    console.log('Modified', data.modifiedRowData);

    if (data.modifiedRowData.length > 0) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.id = this.modalComponent;
      dialogConfig.height = '350px';
      dialogConfig.width = '1000px';

      dialogConfig.data = data;
      const dialogRef = this.dialog.open(ReviewEditedspaceComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((res) => {
        if (res === 'cancel') {
          return;
        } else if (res === 'save') {
          console.log('insiide save', data.modifiedRowData);
          var updatedData = [];
          data.modifiedRowData.forEach((e) => {
            var updatedFields = {
              dock:e.dock,
              container_renban: e.container_renban,
              modified_stocking_pace: e.modified_stocking_pace,
              module_type: e.module_type,
              vanning_from: e.vanning_from,
              vanning_to: e.vanning_to,
              vanDt:e.vandt,
              module_number: e.module_number,
              total_module_qty: e.total_module_qty,
              userid: this.userName,
            };
            updatedData.push(updatedFields);
          });
          // this.successMessage = 'Record has been updated successfully';
          window.scroll(0, 0);

          this.spinner.show();

          this.editStocking(updatedData);

          this.successMessage = successMessage.recordUpdated;
        }
      });
    } else {
      this.warningMessage = warningMessage.selectRowsToEdit;

      window.scroll(0, 0);
    }
  }

  canDeactivate() {
    return this.editEnabled;
  }

  getBatchStatus(callback) {
    var data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
    };

    this.stockingService.pitchBatchStatus(data).subscribe({
      error: (error) => this.errorCallback(error, 'pitchBatchStatus'),
      next: (res) => {
        const status = res.body.data[0]?.status;
       

        if (status === 'RUNNING') {
          this.warningMessage = `${PitchfreezingMsg}`;
          this.spinner.hide();
          this.batchCheck = true;
          this.showDownloadUploadButtons = false;
        } else {
          this.warningMessage = '';
          this.batchCheck = false;
          callback ? callback() : (this.batchCheck = false);
          this.showDownloadUploadButtons = true;
        }
      },
    });
  }

  customErrorCallback = (error,apiName = '') => {
    logErrors(error);
    this.spinner.hide();

    let detailedMessage = 'Something went wrong! Please contact support team.';
    let backendMessage = '';
    if(error?.error?.message){
      backendMessage = error.error.message;
    } else if(error?.message){
      backendMessage = error.message;
    }
    if(backendMessage){
      detailedMessage += `| ${backendMessage}`;
    } else if(apiName){
      detailedMessage += `| Try after some time! Error in ${apiName}`;
    }
    this.warningMessage = detailedMessage;
    this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };
  loadDropdown() {
    this.user = localStorage.getItem('workdayId');
    this.userRole = localStorage.getItem('UserRoles');
    this.userName = localStorage.getItem('UserName');

    const data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole
    };

    this.spinner.show();

    this.stockingService.excelDownloadFilter(data).subscribe({
      next: (res) => {
        if (res?.error) {
          this.customErrorCallback(res.error, 'getCOFilter');
        } else if (res.body === 'No Content') {
          // this.warningMessage = 'No content found for the selected filters.';
          this.dockList = [];
          this.renbanList = [];
          this.filterList = [];
        } else {
          this.filterList = res.body || [];

          this.dockList = [...new Set(this.filterList.map(item => item.dock))]
            .sort((a, b) => String(a).localeCompare(String(b)))
            .map(dock => ({ dock }));

          this.renbanList = [...new Set(this.filterList.map(item => item.container_renban))]
            .sort((a, b) => String(a).localeCompare(String(b)))
            .map(container_renban => ({ container_renban }));
        }

        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        this.errorCallback(error);
      }
    });
  }
  
  openTemplateDialog() {
    if (!this.showDownloadUploadButtons){
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '550px';
    dialogConfig.height = '220px';
    dialogConfig.data = {
      dock: this.dockList,
      mode: 'download',
      dock1: this.selectedDock,
      renbanList: this.renbanList,
      filterList: this.filterList
    };
  
    const dialogRef = this.dialog.open(TemplateStockingPaceMaintenanceComponent, dialogConfig);
  
    const editGetResponse = dialogRef.componentInstance.paceDownloadEventEmitter.subscribe((res) => {
      const limit = 12000;
      let offset = 0;
      const allData: any[] = [];
  
      const requestData = {
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        userid: this.userName,
        dock: res.dock,
        container_renbanFrom: res.selectedrenbanFrom,
        container_renbanTo: res.selectedrenbanTo
      };
  
      this.spinner.show();
  
      const fetchBatch = (offset: number): Promise<void> => {
        return new Promise((resolve, reject) => {
          this.stockingService.downloadPaceData({
            ...requestData,
            offset,
            limit
          }).subscribe({
            next: (response) => {
              const data = response.body?.data || [];
  
              if (data.length > 0) {
                allData.push(...data);
  
                if (data.length === limit) {
                  // Continue fetching next batch
                  fetchBatch(offset + limit).then(resolve).catch(reject);
                } else {
                  resolve(); // All done
                }
              } else {
                resolve(); // No more data
              }
            },
            error: (err) => {
              reject(err);
            }
          });
        });
      };
  
      // Start the batch process
      fetchBatch(offset)
        .then(() => {
          this.spinner.hide();
  
          if (!allData.length) {
            this.warningMessage = warningMessage.noDataFound;
            return;
          }
  
          const exportData = allData.map((e) => ({
            business_entity: e.business_entity,
            dock: e.dock,
            container_renban: e.container_renban,
            module_number: e.module_number,
            stocking_pace: e.stocking_pace,
          }));
  
          const headers = [...this.headers];
          const easternCurrentDate = String(mm().tz(getTimezone(this.namcValue)).format('YYYY-MM-DD_HH:mm:ss'));
          const timestamp = easternCurrentDate
            .split('.')[0]
            .replace('T', '_')
            .split('')
            .filter((d) => d !== '-' && d !== ':')
            .join('');
          const fileName = `stockingpace_download_${this.namcName}_${timestamp}`;
  
          this.excelService.downloadStockingExcel(exportData, fileName, headers);
          this.successMessage = successMessage.downloadSuccess;
  
          setTimeout(() => {
            dialogRef.close();
          }, 1500);
        })
        .catch((err) => {
          this.spinner.hide();
          this.warningMessage = warningMessage.downloadFailed;
          console.error('Download error:', err);
        });
    });
  
    dialogRef.afterClosed().subscribe(() => {
      editGetResponse.unsubscribe();
    });
  }
  
  //  Upload
  modifyRowDataForExport(data) {
    const modifiedDataForExport = [];
    for (const row of data) {
    }
    return modifiedDataForExport;
  }
  
  trim = (val) => (typeof val === "string" ? val.trim() : val);

  parseUploadedRow = (row) => {    
    row = {
      business_entity:row['businessentity'], 
      dock: row['dock'],
      container_renban: row['containerrenban'],
      module_number: row['modulenumber'],
      stocking_pace: this.trim(row['stockingpace']),
    };
    return row;
  };

  mapData = (data) => {

    const validatedData = [];
    data.forEach((row2) => {
      const row = this.parseUploadedRow(row2);
      validatedData.push(row);
    });
    
    return validatedData;
  };

  validateStockingpace(inputArray) {
    const groupMap = new Map(); // key: business_entity-dock-container_renban -> first seen non-null stocking_pace
    const nullRowsMap = new Map(); // key -> array of row indexes with null stocking_pace
    const groupErrors = new Map();
  
    const normalize = (val) => (val === null || val === "" ? null : val);
  
    // --- First pass: detect inconsistencies ---
    inputArray.forEach((row, idx) => {
      const groupKey = `${row.business_entity}-${row.dock}-${row.container_renban}`;
      const normalized = normalize(row.stocking_pace);
  
      if (!groupMap.has(groupKey)) {
        if (normalized !== null) {
          groupMap.set(groupKey, normalized);
        }
  
        if (normalized === null) {
          if (!nullRowsMap.has(groupKey)) nullRowsMap.set(groupKey, []);
          nullRowsMap.get(groupKey).push(idx);
        }
      } else {
        const existing = groupMap.get(groupKey);
  
        if (existing !== null && normalized !== null && existing !== normalized) {
          groupErrors.set(
            groupKey,
            "Stocking pace inconsistent within business entity, dock and container renban"
          );
        } else if (existing !== null && normalized === null) {
          // mark only this null row
          if (!nullRowsMap.has(groupKey)) nullRowsMap.set(groupKey, []);
          nullRowsMap.get(groupKey).push(idx);
        } else if (existing === null && normalized !== null) {
          // (defensive branch; existing won't be null with current logic)
          groupMap.set(groupKey, normalized);
        } else if (existing === null && normalized === null) {
          // both null → track null row
          if (!nullRowsMap.has(groupKey)) nullRowsMap.set(groupKey, []);
          nullRowsMap.get(groupKey).push(idx);
        }
      }
    });
  
    // --- Second pass: row-level validation + attach group errors ---
    return inputArray.map((row, idx) => {
      const { business_entity, dock, container_renban, stocking_pace } = row;
      const remarks: string[] = [];
      const normalized = normalize(stocking_pace);
      const groupKey = `${business_entity}-${dock}-${container_renban}`;
  
      // 1) numeric/negative checks (if provided)
      if (normalized !== null) {
        if (isNaN(normalized)) {
          remarks.push("Stocking pace should be a number");
        } else if (Number(normalized) < 0) {
          remarks.push("Stocking pace cannot be negative");
        }
      }
  
      // 2) group-level inconsistency
      if (groupErrors.has(groupKey)) {
        remarks.push(groupErrors.get(groupKey)!);
      }
  
      // 3) null-only warning for rows that were null, but group has some non-null
      if (groupMap.has(groupKey) && nullRowsMap.has(groupKey) && nullRowsMap.get(groupKey)!.includes(idx)) {
        remarks.push("Stocking pace cannot be null when other rows have a value");
      }
  
      return { ...row, remarks: remarks.join("; ") };
    });
  }




     
  countTotalErrors(validatedArray) {
    let totalErrors = 0;
  
    validatedArray.forEach(row => {
      if (row.remarks) {
        totalErrors += row.remarks.split(";").length;
      }
    });
  
    return totalErrors;
  }
  
  initiatePaceUpload = () => {
    setTimeout(() => {
      if (this.uploading) {
        this.initiatePaceUpload();
        return;
      }

      const data = {
        workid: this.user,
        user_role: this.userRole,
        userid: this.userName,
        fileKey: this.fileName,
      };

      this.removeMessage();
      this.stockingService.uploadPaceData(data).subscribe({
        error: (error) => this.errorCallback(error, 'uploadPaceData'),
        next: (res) => {
          const { error, moduleSeqUpdate, moduleUpdate } = res.body;
          this.spinner.hide();
          if (error) {
            this.warningMessage = warningMessage.reportsNotUpdated;
          } else {
            if (Number(moduleSeqUpdate) === 0 && Number(moduleUpdate) === 0) {
              this.warningMessage = warningMessage.editToReview;
            } else {
              this.successMessage = successMessage.recordUpdated;
            }
          }
        },
      });
    }, 1000);
  };

  validateFile(filename, sizeInBytes) {
    this.uploadError = false;

    this.justFileName = filename;
    this.allowedFilesize = 5000; // Kilobytes

    const allowedFileTypes = ['xlsx', 'xls'];

    const fileType = filename.split('.')[filename.split('.').length - 1];

    const allowedFilesizeInBytes = this.allowedFilesize * 1024;

    if (!allowedFileTypes.includes(fileType)) {
      this.warningMessage = `Only ${allowedFileTypes} files are accepted.`;

      return false;
    }

    if (!(sizeInBytes <= allowedFilesizeInBytes)) {
      this.warningMessage = warningMessage.uploadFileSizeTooBig;

      return false;
    }

    return true;
  }
  @HostListener('drop', ['$event']) onDrop(event) {
    this.onFileChange(event, true);
  }
  onFileChange(event: any, isDrag) {

    if (!this.showDownloadUploadButtons){
      return;
    }
    this.removeMessage();

    this.spinner.show();

    const file: File = event.target.files.item(0);
    const isFileValid = this.validateFile(file?.name, file?.size);

    if (!isFileValid) {
      this.spinner.hide();
      return;
    }

    setTimeout(() => {
      this.files = [file];
      this.excelService.uploadedFile = file;

      this.fileName = file?.name;

      const target: DataTransfer = (isDrag ? event.dataTransfer : event.target) as DataTransfer;

      const reader: FileReader = new FileReader();

      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, {
          type: 'binary',
          cellDates: true,
          dateNF: 'mm/dd/yyyy;@',
        });
        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /*Remove empty spaces and convert to lower case */
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let C = range.s.c; C <= range.e.c; C++) {
          const address = `${XLSX.utils.encode_col(C)}1`; // <-- first row
          if (!ws[address]) {
            continue;
          }
          ws[address].w = ws[address].w.replace(/\s/g, '').toLowerCase();
        }

        /* convert to Json */
        this.excelService.uploadedData = XLSX.utils.sheet_to_json(ws, {
          raw: false,
          dateNF: 'mm/dd/yyyy',
          defval: null
        });

        const mappedData = this.mapData(this.excelService.uploadedData);

        let validatedData = this.validateStockingpace(mappedData);
  
        const errorCount  = this.countTotalErrors(validatedData);
        let header = [];

        if (errorCount > 0) {
          this.uploadError = true;
          this.spinner.hide();
          this.warningMessageUpload = warningMessage.uploadFileError;
          header = this.headersSameAsUIError;
          this.actualFileName = this.getErrorReportName();
        }else{
          this.warningMessageUpload = "";
          validatedData =  validatedData.map(({ remarks, ...rest }) => rest); //remove remarks column
          this.uploadError = false;
          header = this.headersSameAsUI;
          this.actualFileName = "";
        }
        this.excelService.uploadedData = validatedData;
        event.target.value = null; // To clear the uploaded file

        this.validating = true;
        console.log('validatedData length',[...validatedData].length);
        this.uploadToS3(validatedData,header);
        if (errorCount === 0) {          
          this.initiatePaceUpload();
        }
        return;
      };
      reader.readAsBinaryString(target.files[0]);
      this.fileInput.nativeElement.value = null;
    }, 1000);
  }
  getFileName() {
    let easternCurrentDate = String(mm().tz(getTimezone(this.namcValue)).format('YYYY-MM-DD_HH:mm:ss'));
    const Etimestamp = easternCurrentDate
      .split('.')[0]
      .replace('T', '_')
      .split('')
      .filter((d) => d !== '-' && d !== ':')
      .join('');

    return this.uploadError
      ? `stockingpace/${this.namcName}/error/stockingpace_error_${this.user}_${Etimestamp}.xlsx`
      : `stockingpace/${this.namcName}/success/stockingPace_upload_${this.user}_${Etimestamp}.xlsx`;
  }
  getExportData() {
    const data = [];
    const dataToExport = this.uploadError
      ? this.excelService.uploadedData
      : this.exportData;

    dataToExport.forEach((row, index) => {
      const newRow = {
        business_entity: this.namcValue,
        dock: row.dock,
        container_renban: row.container_renban,
        module_number: row.module_number,
        stocking_pace: row.stocking_pace,
        group: [index + 1],
        errors: []
      };

      data.push(newRow);
    });

    return data;
  }

  getWrappedColumn(v) {
    return { v, t: 's', s: { alignment: { wrapText: true } } };
  }

  uploadToS3(data, header): void {
    this.spinner.show();

    this.fileName = this.getFileName();

    this.uploading = true;
    setTimeout(async () => {
      this.fileBuffer = await this.excelService.getFileBuffer(data, this.fileName, header);

      this.uploadExcelDataToS3({ fileName: this.fileName });

      if (this.uploadError) {
        this.spinner.hide();
      }
    }, 100);
  }
  uploadExcelDataToS3({ fileName }) {
    const data = {
      workid: this.user,
      user_role: this.userRole,
      fileName: fileName,
    };
    
    this.flalService.getExcelFileUrl(data).subscribe({
      error: (error) => this.errorCallback(error,'getExcelFileUrl'),
      next: (response) => {
        if (response.body.signedUrl) {
          const a = document.createElement('a');
          a.href = response.body.signedUrl;
          console.log(this.fileBuffer,'fileBuffer......')
          this.flalService.putDatainExcel(this.fileBuffer, a.href).subscribe({
            error: (error) => this.errorCallback(error,'putDatainExcel'),
            next: (res) => {
              this.uploading = false;
            },
          });
        }
      },
    });
  }
  getErrorReport() {    
    if (this.excelService.uploadedData.length > 0) {
      this.excelService.downloadStockingExcel(this.excelService.uploadedData,
        this.actualFileName,
        this.headersSameAsUIError);
    }
  }

  getErrorReportName(){
    let easternCurrentDate = String(mm().tz(getTimezone(this.namcValue)).format('YYYY-MM-DD_HH:mm:ss'));
    const Etimestamp = easternCurrentDate
      .split('.')[0]
      .replace('T', '_')
      .split('')
      .filter((d) => d !== '-' && d !== ':')
      .join('');
    return `stockingpace_error_${this.namcName}_${Etimestamp}.xlsx`;
  }
}